import type { PreferencesConfig } from '@models/company'
import type { UserRole } from '@models/user'

export const getPagesVisibility = (
  preferences: PreferencesConfig | undefined,
  userRole: UserRole = 'COMPANY_DISPATCHER',
): ((key: keyof Omit<PreferencesConfig, 'settings'>) => boolean) => {
  return (key: keyof Omit<PreferencesConfig, 'settings'>) => {
    const item = preferences?.[key]

    if (typeof item === 'object' && item !== null) {
      if ('hidden' in item && item.hidden === true) {
        return false
      }

      if ('rolesVisibility' in item && item.rolesVisibility && userRole) {
        return item.rolesVisibility.includes(userRole)
      }
    }

    return true
  }
}
